import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaChartBar, FaUsers, FaShoppingCart, FaBoxes, FaMoneyBillWave,
  FaCog, FaSignOutAlt, FaChevronDown, FaChevronUp, FaTicketAlt,
  FaUserTie, FaClipboardCheck, FaFileAlt, FaHandshake, FaTags,
  FaHome, FaThLarge, FaPlus, FaCalendarAlt, FaClipboardList,
  FaHardHat, FaBuilding, FaIdCard, FaUserCog, FaTools, FaIdBadge,
  FaBook, FaMap, FaFileDownload, FaInfoCircle, FaFileUpload
} from 'react-icons/fa';
import { useAuth } from '../../hooks/useAuth';

const Sidebar = () => {
  const location = useLocation();
  const { hasRole } = useAuth();
  const [expanded, setExpanded] = useState({});

  // Efeito para controlar qual menu fica aberto com base na rota atual
  useEffect(() => {
    const path = location.pathname;
    
    // Lógica para determinar qual categoria de menu deve estar expandida
    const newExpandedState = {
      dashboard: path.startsWith('/dashboard'),
      orders: path.startsWith('/catalog') || path.startsWith('/orders') || path.startsWith('/admin/pedidos-carrinho'),
      materialApoio: path.startsWith('/material-apoio'),
      // CORREÇÃO: Unifica todas as rotas de credenciais para abrir o mesmo menu
      credenciais: path.startsWith('/montadoras') || path.startsWith('/credenciais'),
      controleAcesso: path.startsWith('/controle-acesso') || path.startsWith('/acessos'),
      admin: path.startsWith('/admin'),
    };
    
    setExpanded(newExpandedState);
  }, [location.pathname]);

  // Função para abrir/fechar uma categoria de menu
  const toggleCategory = (category) => {
    setExpanded(prev => ({
      // Fecha todos os outros menus
      ...Object.keys(prev).reduce((acc, key) => ({ ...acc, [key]: false }), {}),
      // Abre ou fecha o menu clicado
      [category]: !prev[category]
    }));
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>MM Eventos</h2>
        <span className="subtitle">Portal de Expositores</span>
      </div>
      
      <div className="sidebar-content">
        {/* Item de menu Início */}
        <Link to="/expositor-home" className={`sidebar-menu-item ${isActive('/expositor-home') ? 'active' : ''}`}>
          {isActive('/expositor-home') && <div className="active-indicator"></div>}
          <FaHome className="menu-icon" />
          <span className="menu-label">Início</span>
        </Link>
        
        {/* NOVO ITEM: Relatórios - disponível para admin e expositor */}
        <Link to="/relatorios" className={`sidebar-menu-item ${isActive('/relatorios') ? 'active' : ''}`}>
          {isActive('/relatorios') && <div className="active-indicator"></div>}
          <FaChartBar className="menu-icon" />
          <span className="menu-label">Relatórios</span>
        </Link>
        
        {/* Menu Pedidos */}
        <div className="sidebar-category-header" onClick={() => toggleCategory('orders')}>
          <span>Pedidos</span>
          {expanded.orders ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
        </div>
        {expanded.orders && (
          <div className="sidebar-category-content">
            <Link to="/catalog" className={`sidebar-menu-item ${isActive('/catalog') ? 'active' : ''}`}>
              {isActive('/catalog') && <div className="active-indicator"></div>}
              <FaBoxes className="menu-icon" />
              <span className="menu-label">Novo Pedido</span>
            </Link>
            <Link to="/orders" className={`sidebar-menu-item ${isActive('/orders') ? 'active' : ''}`}>
              {isActive('/orders') && <div className="active-indicator"></div>}
              <FaClipboardList className="menu-icon" />
              <span className="menu-label">Meus Pedidos</span>
            </Link>
            {/* NOVO SUBMENU: Pedidos no Carrinho - visível apenas para admin */}
            {hasRole('admin') && (
              <Link to="/admin/pedidos-carrinho" className={`sidebar-menu-item ${isActive('/admin/pedidos-carrinho') ? 'active' : ''}`}>
                {isActive('/admin/pedidos-carrinho') && <div className="active-indicator"></div>}
                <FaShoppingCart className="menu-icon" />
                <span className="menu-label">Pedidos no Carrinho</span>
              </Link>
            )}
          </div>
        )}
        
        {/* Menu Material de Apoio */}
        <div className="sidebar-category-header" onClick={() => toggleCategory('materialApoio')}>
          <span>Material de Apoio</span>
          {expanded.materialApoio ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
        </div>
        {expanded.materialApoio && (
          <div className="sidebar-category-content">
            <Link to="/material-apoio/planta" className={`sidebar-menu-item ${isActive('/material-apoio/planta') ? 'active' : ''}`}>
              <FaMap className="menu-icon" /> <span className="menu-label">Planta do Evento</span>
            </Link>
            <Link to="/material-apoio/manual" className={`sidebar-menu-item ${isActive('/material-apoio/manual') ? 'active' : ''}`}>
              <FaBook className="menu-icon" /> <span className="menu-label">Manual do Expositor</span>
            </Link>
          </div>
        )}
        
        {/* Menu Credenciais (Unificado) */}
        <div className="sidebar-category-header" onClick={() => toggleCategory('credenciais')}>
          <span>Credenciais</span>
          {expanded.credenciais ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
        </div>
        {expanded.credenciais && (
          <div className="sidebar-category-content">
            <Link to="/montadoras/empresas" className={`sidebar-menu-item ${isActive('/montadoras/empresas') ? 'active' : ''}`}>
              <FaBuilding className="menu-icon" /> <span className="menu-label">Empresas/Montadoras</span>
            </Link>
            <Link to="/montadoras/montadores" className={`sidebar-menu-item ${isActive('/montadoras/montadores') ? 'active' : ''}`}>
              <FaHardHat className="menu-icon" /> <span className="menu-label">Credencial Montador</span>
            </Link>
            {/* LINHA ADICIONADA AQUI */}
            <Link to="/credenciais/prestador" className={`sidebar-menu-item ${isActive('/credenciais/prestador') ? 'active' : ''}`}>
              <FaTools className="menu-icon" /> <span className="menu-label">Credencial Prestador</span>
            </Link>
            <Link to="/credenciais-expositor/cadastro" className={`sidebar-menu-item ${isActive('/credenciais-expositor/cadastro') ? 'active' : ''}`}>
              <FaIdBadge className="menu-icon" /> <span className="menu-label">Credencial Expositor</span>
            </Link>
          </div>
        )}
        
        {/* Menus de Administração (visíveis apenas para admin) */}
        {hasRole('admin') && (
          <>
            <div className="sidebar-category-header" onClick={() => toggleCategory('controleAcesso')}>
              <span>Controle de Acesso</span>
              {expanded.controleAcesso ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
            </div>
            {expanded.controleAcesso && (
              <div className="sidebar-category-content">
                <Link to="/controle-acesso" className={`sidebar-menu-item ${isActive('/controle-acesso') ? 'active' : ''}`}>
                  <FaIdCard className="menu-icon" /> <span className="menu-label">Controle de Acesso</span>
                </Link>
                <Link to="/acessos" className={`sidebar-menu-item ${isActive('/acessos') ? 'active' : ''}`}>
                  <FaUsers className="menu-icon" /> <span className="menu-label">Credenciais</span>
                </Link>
              </div>
            )}
            
            <div className="sidebar-category-header" onClick={() => toggleCategory('admin')}>
              <span>Administração</span>
              {expanded.admin ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
            </div>
            {expanded.admin && (
              <div className="sidebar-category-content">
                <Link to="/admin/events" className={`sidebar-menu-item ${isActive('/admin/events') ? 'active' : ''}`}>
                  <FaCalendarAlt className="menu-icon" /> <span className="menu-label">Eventos</span>
                </Link>
                <Link to="/admin/products" className={`sidebar-menu-item ${isActive('/admin/products') ? 'active' : ''}`}>
                  <FaBoxes className="menu-icon" /> <span className="menu-label">Produtos</span>
                </Link>
                <Link to="/admin/categories" className={`sidebar-menu-item ${isActive('/admin/categories') ? 'active' : ''}`}>
                  <FaTags className="menu-icon" /> <span className="menu-label">Categorias</span>
                </Link>
                <Link to="/admin/exhibitors" className={`sidebar-menu-item ${isActive('/admin/exhibitors') ? 'active' : ''}`}>
                  <FaUsers className="menu-icon" /> <span className="menu-label">Expositores</span>
                </Link>
                <Link to="/admin/orders" className={`sidebar-menu-item ${isActive('/admin/orders') ? 'active' : ''}`}>
                  <FaClipboardCheck className="menu-icon" /> <span className="menu-label">Aprovação de Pedidos</span>
                </Link>
                <Link to="/admin/materiais-apoio" className={`sidebar-menu-item ${isActive('/admin/materiais-apoio') ? 'active' : ''}`}>
                  <FaFileUpload className="menu-icon" /> <span className="menu-label">Materiais de Apoio</span>
                </Link>
              </div>
            )}
          </>
        )}
      </div>

      <div className="sidebar-footer">
        <div className="user-info">
          <span className="text-muted">Logado como:</span>
          <div className="roles-container">
            {hasRole('admin') && <span className="role-badge">Administrador</span>}
            {hasRole('expositor') && <span className="role-badge">Expositor</span>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;